import { useEffect, useRef, useState } from "react";
import clove from "../assets/form/clove_3.png";

const CustomCursor = () => {
  const [pos, setPos] = useState({ x: 0, y: 0 });
  const [leaves, setLeaves] = useState([]);
  const lastTrailTime = useRef(0);

  useEffect(() => {
    const move = (e) => {
      setPos({ x: e.clientX, y: e.clientY });

      // 🔥 TRAIL (throttled)
      const now = Date.now();
      if (now - lastTrailTime.current > 50) {
        lastTrailTime.current = now;

        const leaf = {
          id: now + Math.random(),
          x: e.clientX,
          y: e.clientY,
          offsetX: Math.random() * 60 - 30,
          offsetY: Math.random() * 60 - 30,
          trail: true,
        };

        setLeaves((prev) => [...prev, leaf]);

        setTimeout(() => {
          setLeaves((prev) => prev.filter((p) => p.id !== leaf.id));
        }, 500);
      }
    };

    const burst = (e) => {
      const particles = Array.from({ length: 10 }).map((_, i) => ({
        id: Date.now() + i,
        x: e.clientX,
        y: e.clientY,
        offsetX: Math.random() * 140 - 70,
        offsetY: Math.random() * 140 - 70,
        trail: false,
      }));

      setLeaves((prev) => [...prev, ...particles]);

      setTimeout(() => {
        setLeaves((prev) =>
          prev.filter((p) => !particles.some((pt) => pt.id === p.id))
        );
      }, 700);
    };

    document.addEventListener("mousemove", move);
    document.addEventListener("pointerdown", burst, true);

    return () => {
      document.removeEventListener("mousemove", move);
      document.removeEventListener("pointerdown", burst, true);
    };
  }, []);

  return (
    <>
      {/* Custom Cursor */}
      <img
        src={clove}
        alt="cursor"
        style={{
          position: "fixed",
          left: pos.x,
          top: pos.y,
          transform: "translate(-50%, -50%)",
          pointerEvents: "none",
          width: "25px",
          zIndex: 100000,
          display: window.innerWidth < 768 ? "none" : "block"
        }}
      />

      {/* Leaves */}
      {leaves.map((leaf) => (
        <div
          key={leaf.id}
          className={`leaf ${leaf.trail ? "trail" : "burst"}`}
          style={{
            left: leaf.x,
            top: leaf.y,
            "--x": `${leaf.offsetX}px`,
            "--y": `${leaf.offsetY}px`,
            zIndex: 100000,
          }}
        />
      ))}
    </>
  );

 
};

export default CustomCursor;
